package com.partejar.app.feature.equipe.data.remote

import com.partejar.app.feature.equipe.data.EquipeMember
import com.partejar.app.feature.equipe.data.ProfessionalRegistration

class EquipeRemoteMapper {
    fun map(dto: EquipeMemberDto) = EquipeMember(
        id = dto.membroWorkspaceId,
        userId = dto.usuarioId,
        name = dto.nome,
        email = dto.email,
        profileCode = dto.perfil.codigo,
        profileName = dto.perfil.nome,
        professionalCategory = dto.categoriaProfissional,
        selectedProfessionalRegistration = dto.registroProfissional?.let {
            ProfessionalRegistration(
                it.id,
                it.categoriaProfissional ?: dto.categoriaProfissional,
                it.conselho,
                it.numero,
                it.uf,
                it.ativo
            )
        },
        active = dto.ativo
    )
    fun registration(dto: RegistroProfissionalEquipeDto) = ProfessionalRegistration(
        dto.id,
        dto.categoriaProfissional ?: "OUTRO",
        dto.conselho,
        dto.numero,
        dto.uf,
        dto.ativo
    )
}
